<template>
  <div class="card">
    <div class="course">
      <div class="course__title">
        <span
          class="word-breaker"
          data-toggle="tooltip"
          :title="course.name"
        >{{ course.name }}</span>
        <br>

        <small
          class="word-breaker"
          data-toggle="tooltip"
          :title="course.code"
        >{{ course.code }}</small>

        <template
          v-if="hasExemption"
        >
          <br>
          <span
            class="fa fa-shield"
          />
          <small
            class="word-breaker"
            data-toggle="tooltip"
            :title="trans('student.course_context.tooltips.exemption')"
          >{{ trans('student.course_context.types.exemption') }}</small>
        </template>

        <template v-if="hasSubscribable && hasMySubscription && subscribable.hasQuestions">
          <br>
          <a
            class="course__subscription-details hidden-print"
            @click.stop="showDetails = !showDetails"
          >
            <span
              class="fa"
              :class="{ 'fa-chevron-down': showDetails, 'fa-chevron-right':!showDetails }"
            /> {{ trans('studyplan.subscription_details') }}
          </a>
          <template
            v-for="myAnswer in myAnswers"
          >
            <div
              v-if="showDetails"
              :key="myAnswer.id"
              class="course__subscription-details__question hidden-print"
            >
              <i
                class="fa fa-question"
                aria-hidden="true"
              /> <span v-safe-html="myAnswer.question != null ? myAnswer.question : getQuestionFromTemplate(myAnswer.question_template_id)" /> <br>
              <i
                class="fa fa-comment-o"
                aria-hidden="true"
              /> <span>{{ myAnswer.parsed_answer != null ? myAnswer.parsed_answer : myAnswer.answer }}</span>
            </div>
            <div
              :key="myAnswer.id"
              class="course__subscription-details__question visible-print"
            >
              <i
                class="fa fa-question"
                aria-hidden="true"
              /> <span v-safe-html="myAnswer.question != null ? myAnswer.question : getQuestionFromTemplate(myAnswer.question_template_id)" /> <br>
              <i
                class="fa fa-comment-o"
                aria-hidden="true"
              /> <span>{{ myAnswer.parsed_answer != null ? myAnswer.parsed_answer : myAnswer.answer }}</span>
            </div>
          </template>
        </template>
      </div>
      <div
        v-if="ectsShown"
        class="course__ects"
      >
        {{ course.ects == null ? '-' : displayEcts(course.ects) }}
        <slot
          name="unsubscription"
          :unsubscriptionCourseName="course.name"
          :unsubscriptionSubscribableId="subscribable.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { COURSE_CONTEXT_EXEMPTION } from '@/constants'
import { displayFloatLocalized } from '@/helpers'
import { mapState } from 'vuex'

export default {
  name: 'Course',
  props: {
    course: {
      required: true,
      type: Object,
    },
    ectsShown: {
      required: true,
      type: Boolean,
    },
    subscribable: {
      required: false,
      type: Object,
    },
    mySubscription: {
      required: false,
      type: Object,
    },
  },
  data () {
    return {
      showDetails: false,
    }
  },
  computed: {
    ...mapState({
      myCourseContexts (state) {
        return this.course.myContexts.map(contextId => state.subscribables.studentCourseContexts[contextId])
      },

      myAnswers (state) {
        if (this.hasSubscribable && this.subscribable.myAnswers != null) {
          return this.subscribable.myAnswers.map(answerId => state.subscribables.studentSubscribableAnswers[answerId])
        }

        return []
      },

      questionTemplates (state) {
        if (this.hasSubscribable && this.subscribable.questionTemplates != null) {
          return this.subscribable.questionTemplates.map(templateId => state.subscribables.questionTemplates[templateId])
        }

        return []
      },
    }),

    hasQuestion () {
      return this.hasSubscribable && this.subscribable.question != null && this.subscribable.question != ''
    },
    hasSubscribable () {
      return this.subscribable != null
    },
    hasMySubscription () {
      return this.mySubscription != null
    },
    hasExemption () {
      return this.myCourseContexts.some(function (courseContext) {
        return courseContext.type === COURSE_CONTEXT_EXEMPTION
      })
    },
  },
  methods: {
    displayEcts (ec) {
      return displayFloatLocalized(ec, Lang.locale)
    },

    getQuestionFromTemplate (templateId) {
      return this.questionTemplates.filter(template => template.template_id === templateId)[0].question
    },
  },
}
</script>

<style scoped lang="scss">
    .course {
        max-width: 250px;
        min-height: 75px;
        display: flex;

        &__title {
            flex: 1 1 auto;
            padding: 10px;
            border:1px solid #eee;
        }

        &__ects {
            flex: 0 0 40px;
            padding-top: 10px;
            text-align: center;
            background: #eeeeee;
            position: relative;
        }

        &__subscription-details {
            cursor: pointer;
            font-size: 10px;

            &__question {
                font-size: 12px;
            }
        }
    }

    .card {
        margin-bottom: 10px !important;
        margin-left: 10px;
        margin-right: 10px;
    }

    @media print {

        .card {
            margin-bottom: 5px !important;
            margin-left: 10px;
            margin-right: 10px;
            border-bottom: 1px solid #eee;
        }

        .course {
            width: 100% !important;
        }
    }

  .word-breaker {
    word-break: break-all;
  }
</style>
